import React, { useContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import context from '../../context/product/context';

const ProgramLogo: React.FC<{}> = () => {
	const ctxt = useContext(context);
	const data = useStaticQuery(
		graphql`
		{
			 file(dir: {regex: "/program-logo/"}) {
				childImageSharp {
					gatsbyImageData (
						placeholder: NONE
					)
				}
			}
		}
		`
	);

	return (
		<>
			{data.file &&
				<div className="max-w-sm mx-auto">
					<GatsbyImage
						className="w-auto"
						imgClassName="print:w-full"
						image={getImage(data.file)}
						alt={ctxt.json.params.brandName + " Logo"}
						loading="eager"
					/>
				</div>
			}
		</>
	)
};

export default ProgramLogo;
